import {
  TOPIC_CONTENT_SOURCES,
  type TopicContentSource,
} from "./topic-content-sources";

export const RENTAL_APPLICATION_SOURCES_A = [
  {
    sourceId: "rental-application-source-finding",
    topicId: "rental-application",
    title: "Finding and applying for a rental property",
    publisher: "NSW Fair Trading",
    url: "https://www.nsw.gov.au/housing-and-construction/renting-a-place-to-live/starting-a-residential-tenancy/finding-and-applying-for-a-rental-property",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NSW Government 공식 본문에서 property inspection, application assessment, holding fee, allowed costs, rent bidding prohibition과 complaint 경로를 확인",
    reviewStatus: "live_verified",
    claimScope: "NSW private rental 탐색·신청·승인 후 초기 절차",
    followUp: "신청 직전 current advertised rent, application form, allowed payment와 material facts를 재확인",
  },
  {
    sourceId: "rental-application-source-privacy",
    topicId: "rental-application",
    title: "When a prospective tenant applies for a property",
    publisher: "NSW Fair Trading Commissioner",
    url: "https://www.nsw.gov.au/housing-and-construction/rental-forms-surveys-and-data/resources/fair-trading-commissioners-guidance/when-a-prospective-tenant-applies-for-a-property",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "Fair Trading Commissioner 공식 guidance에서 data minimisation, identity sighting, rent capacity, alternative evidence, third-party platform와 credit-report 제한을 확인",
    reviewStatus: "live_verified",
    claimScope: "prospective tenant 개인정보의 합리적 최소 수집과 application evidence best practice",
    followUp: "platform privacy notice, document retention·deletion과 consent 범위를 제출 전에 확인",
  },
  {
    sourceId: "rental-application-source-discrimination",
    topicId: "rental-application",
    title: "Discrimination against prospective tenants",
    publisher: "NSW Fair Trading",
    url: "https://www.nsw.gov.au/housing-and-construction/rules/discrimination-against-prospective-tenants",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NSW Government 공식 본문에서 prospective tenant protected attributes, permitted selection considerations와 complaint support를 확인",
    reviewStatus: "live_verified",
    claimScope: "NSW rental application selection에서 금지되는 discrimination과 지원 경로",
    followUp: "문제 발생 시 advertisement, application, messages와 comparative terms를 보관하고 current complaint body 확인",
  },
  {
    sourceId: "rental-application-source-database",
    topicId: "rental-application",
    title: "Tenancy databases",
    publisher: "NSW Fair Trading",
    url: "https://www.nsw.gov.au/housing-and-construction/rules/tenancy-databases",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NSW Government 공식 본문에서 tenancy database listing·notification, applicant disclosure, copy·correction·removal 권리를 확인",
    reviewStatus: "live_verified",
    claimScope: "NSW prospective tenant의 tenancy database 확인과 오류 대응 권리",
    followUp: "database operator, listing landlord·agent, notification date와 current challenge procedure 확인",
  },
] as const satisfies readonly TopicContentSource[];

const mutableSources = TOPIC_CONTENT_SOURCES as unknown as TopicContentSource[];
for (const source of RENTAL_APPLICATION_SOURCES_A) {
  if (!mutableSources.some((existing) => existing.sourceId === source.sourceId)) {
    mutableSources.push(source);
  }
}
